import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Label, Form, FormGroup, Input, Button, FormFeedback, Col, Row } from 'reactstrap';
import { ButtonText, NewsLetterStyle } from '../../../../StyledComponents';
import InputPasswordToggle from "@components/input-password-toggle"
import { IoCaretBackOutline } from 'react-icons/io5';

const AddEasypaisaJazzcash = (props) => {
    const { name, onSwitchTab, onCancel } = props;

    // Define validation schema using Yup
    const JazzCashEasyPaisaSchema = yup.object().shape({
        accountType: yup
            .string()
            .required('Bank Name is required'),
        accountHolderName: yup
            .string()
            .required('Account Holder name is required'),
        mobileNumber: yup
            .string()
            .matches(/^[0-9]{10}$/, "Mobile number must be exactly 10 digits")
            .required('Mobile Number is required'),
        accountPin: yup
            .string()
            .matches(/^[0-9]{6}$/, "Account Pin must be exactly 6 digits")
            .required('Account Pin is required'),
    });

    // Use react-hook-form to handle form
    const { control, handleSubmit, formState: { errors } } = useForm({
        mode: 'onChange',
        resolver: yupResolver(JazzCashEasyPaisaSchema),
    });

    // Handle form submission
    const onSubmit = (data) => {
        console.log("on submit data: ", data);
        {
            name !== "Reload Gift Card" ? onSwitchTab() : ''
        }

    };

    return (
        <>
            <Row className='m-0 p-0'>
                {
                    name == "Reload Gift Card" ?
                        <>
                            <Col xl='1' lg='1' md='1' sm='12' xs='12'>
                                <NewsLetterStyle style={{ fontSize: '18px', cursor: 'pointer' }} onClick={() => onCancel(false)}> <IoCaretBackOutline /> Back</NewsLetterStyle>
                            </Col>
                        </> : ""

                }
                <Col xl='11' lg='11' md='11' sm='12' xs='12'>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                        <NewsLetterStyle style={{ fontWeight: '700' }}>Add Easypaisa/Jazzcash</NewsLetterStyle>
                    </div>

                    <div>

                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <Row className='w-100'>
                                <Col xl="6" lg='6' md='6' sm="12" xs='12'>
                                    <FormGroup>
                                        <Label className='form-label' for='account-type'>Account type</Label>
                                        <Controller
                                            name="accountType"
                                            control={control}
                                            id='account-type'
                                            render={({ field }) => (
                                                <Input
                                                    {...field}
                                                    invalid={!!errors.accountType} // Use invalid prop for styling
                                                    placeholder='Add bank name'
                                                />
                                            )}
                                        />
                                        {errors.accountType && <FormFeedback>{errors.accountType.message}</FormFeedback>}
                                    </FormGroup>
                                </Col>
                                <Col xl="6" lg='6' md='6' sm="12" xs='12'>
                                    <FormGroup>
                                        <Label className='form-label' for='account-holder-name'>Account holder name</Label>
                                        <Controller
                                            name="accountHolderName"
                                            control={control}
                                            id='account-holder-name'
                                            render={({ field }) => (
                                                <Input
                                                    {...field}
                                                    invalid={!!errors.accountHolderName} // Use invalid prop for styling
                                                    placeholder='Add account holder name'
                                                />
                                            )}
                                        />
                                        {errors.accountHolderName && <FormFeedback>{errors.accountHolderName.message}</FormFeedback>}
                                    </FormGroup>
                                </Col>
                                <Col xl="6" lg='6' md='6' sm="12" xs='12'>
                                    <FormGroup>
                                        <Label className='form-label' for='account-number'>Mobile number</Label>
                                        <Controller
                                            name="mobileNumber"
                                            control={control}
                                            id='account-number'
                                            render={({ field }) => (
                                                <Input
                                                    {...field}
                                                    invalid={!!errors.mobileNumber} // Use invalid prop for styling
                                                    placeholder='Add account number'
                                                    type='number'
                                                />
                                            )}
                                        />
                                        {errors.mobileNumber && <FormFeedback>{errors.mobileNumber.message}</FormFeedback>}
                                    </FormGroup>
                                </Col>
                                <Col xl="6" lg='6' md='6' sm="12" xs='12'>
                                    <FormGroup>
                                        <Label className='form-label' for='account-pin'>Account Pin</Label>
                                        <Controller
                                            name="accountPin"
                                            control={control}
                                            id='account-pin'
                                            render={({ field }) => (
                                                <Input
                                                    {...field}
                                                    invalid={!!errors.accountPin} // Use invalid prop for styling
                                                    placeholder='Add branch code'
                                                    type='number'
                                                />
                                            )}
                                        />
                                        {errors.accountPin && <FormFeedback>{errors.accountPin.message}</FormFeedback>}
                                    </FormGroup>
                                </Col>
                                <Col className='mb-2 d-flex justify-content-end'>
                                    <button type='submit' className='btn' style={{ backgroundColor: '#41B8E4', color: 'white' }}>Add Account</button>
                                </Col>
                            </Row>

                        </Form>
                    </div>

                </Col>
            </Row>

        </>
    );
};

export default AddEasypaisaJazzcash;
